/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    //     blocks.push({
    //         location: 'VARIABLE_DECLARATIONS',
    //         blockType: BlockType.CODE,
    //         template: `
    // struct k_timer lvgl_display_lib_timer;`,
    //     });

    //     blocks.push({
    //         location: 'FUNCTION_DECLARATIONS',
    //         blockType: BlockType.CODE,
    //         template: `
    // extern void timer_interruption_handler_display_lib(struct k_timer *timer_id);`,
    //     });

    //     blocks.push({
    //         location: 'FUNCTION_DEFINITIONS',
    //         blockType: BlockType.CODE,
    //         template: `
    // void timer_interruption_handler_display_lib(struct k_timer *timer_id) {
    //     // lv_task_handler();
    // }`,
    //     });

    //     blocks.push({
    //         location: 'boot',
    //         blockType: BlockType.CODE,
    //         template: `
    // k_timer_init(&lvgl_display_lib_timer, timer_interruption_handler_display_lib, NULL);
    // k_timer_start(&lvgl_display_lib_timer, K_MSEC(1000), K_MSEC(1000));
    // `,
    //     });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
main_tick_interval = 100;
`,
    });

    blocks.push({
        location: 'MAIN',
        blockType: BlockType.CODE,
        template: `
lv_task_handler();
`,
    });

    blocks.push({
        location: 'PRJ_CONF',
        template: `
CONFIG_DISPLAY=y
# lvgl
CONFIG_LVGL=y
# CONFIG_LV_USE_THEME_DEFAULT=n
# CONFIG_LV_USE_THEME_BASIC=y
CONFIG_LV_MEM_CUSTOM=y
CONFIG_LV_USE_LOG=y
CONFIG_LV_USE_LABEL=y
CONFIG_LV_USE_BTN=y
CONFIG_LV_USE_ARC=y
CONFIG_LV_USE_IMG=y
CONFIG_LV_USE_MONKEY=y
CONFIG_LV_FONT_MONTSERRAT_14=y
CONFIG_LV_FONT_MONTSERRAT_8=y
# CONFIG_LV_Z_VDB_SIZE=32
CONFIG_LV_Z_MEM_POOL_SIZE=16384
        `,
    });

    blocks.push({
        location: 'APP_OVERLAY_INCLUDES',
        blockType: BlockType.CODE,
        template: `
#include <zephyr/dt-bindings/mipi_dbi/mipi_dbi.h>
`,
    });

    blocks.push({
        location: 'GLOBAL_INCLUDES',
        template: `
#include <zephyr/drivers/display.h>
#include <lvgl.h>
#include <lvgl_input_device.h>
        `,
    });
    let SCREENS: any[] = [];
    const LCD_WIDGET_TYPES = ['lcd_text_widget', 'lcd_image_widget'];
    for (let i = 0; i < feature.project.features.length; i++) {
        const currentFeature = feature.project.features[i];
        const tmpSCREENS = currentFeature.getSettingValue('SCREENS');
        if (tmpSCREENS === undefined) {
            continue;
        }
        for (let j = 0; j < tmpSCREENS.length; j++) {
            const SCREEN = tmpSCREENS[j];
            const WIDGETS = SCREEN.getSettingValue('WIDGETS');
            let isDisplayFeature = false;
            for (let k = 0; k < WIDGETS.length; k++) {
                const WIDGET = WIDGETS[k];
                if (LCD_WIDGET_TYPES.includes(WIDGET.id)) {
                    isDisplayFeature = true;
                    break;
                }
            }
            if (isDisplayFeature) {
                SCREENS = SCREENS.concat(SCREEN);
                const NAME = currentFeature.getSettingValue('NAME');
                blocks.push({
                    location: 'boot',
                    blockType: BlockType.CODE,
                    template: `${NAME}_device = DEVICE_DT_GET(DT_CHOSEN(zephyr_display));
            if (!device_is_ready(${NAME}_device)) {
                LOG_ERR("${NAME} Display Device not ready, aborting");
            }
            display_blanking_off(${NAME}_device);    
            `,
                });
            }
        }
    }

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
lv_style_t font_large_style;
lv_style_t font_small_style;
lv_style_init(&font_large_style);
lv_style_set_text_font(&font_large_style, &lv_font_montserrat_14);
lv_style_init(&font_small_style);
lv_style_set_text_font(&font_small_style, &lv_font_montserrat_8);
`,
    });

    for (let j = 0; j < SCREENS.length; j++) {
        const screen = SCREENS[j];
        const WIDGETS = screen.getSettingValue('WIDGETS');

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
lv_obj_t * scr = lv_scr_act();
lv_obj_remove_style_all(scr);
lv_obj_set_style_bg_color(scr, lv_color_hex(0x${screen.getSettingValue('BACKCOLOR').replace('#', '')}), 0);
lv_obj_set_style_bg_opa(scr, LV_OPA_COVER, 0);

`,
        });

        for (let i = 0; i < WIDGETS.length; i++) {
            const widget = WIDGETS[i].getWidgetObject();
            if (widget.type === 'lcd_text_widget') {
                blocks.push({
                    location: 'boot',
                    blockType: BlockType.CODE,
                    template: `
lcd_${widget.id} = lv_label_create(lv_scr_act());
lv_obj_align(lcd_${widget.id}, LV_ALIGN_TOP_LEFT, ${widget.x}, ${widget.y});
lv_obj_set_style_text_color(lv_scr_act(), lv_color_hex(0x${widget.color.replace('#', '')}), LV_PART_MAIN);
lv_obj_add_style(lcd_${widget.id}, ${widget.font === 'LCD_STD_FONT' ? '&font_large_style' : '&font_small_style'}, LV_STATE_DEFAULT);
lv_label_set_text(lcd_${widget.id}, "${widget.text}");
`,
                });

                blocks.push({
                    location: 'VARIABLE_DECLARATIONS',
                    blockType: BlockType.CODE,
                    template: `
lv_obj_t *lcd_${widget.id};
`,
                });
            } else if (widget.type === 'lcd_image_widget') {
                //                 const IMG_FILE = widget.img ? widget.img.split('\n')[0] : '';
                //                 blocks.push({
                //                     location: 'display_init_widgets',
                //                     blockType: BlockType.CODE,
                //                     template: `
                // ${widgetsArrayName}.append(DisplayWidget(
                //     type='image',
                //     x=${widget.x},
                //     y=${widget.y},
                //     width=${widget.w},
                //     height=${widget.h},
                //     screen=${j},
                //     text='${IMG_FILE}',
                // ))`,
                //                 });
            }
        }
    }

    return blocks;
};
